import React from 'react';
import {formatAmount} from '../utils/banTypeClassifier';

const PaymentNotificationLabel = ({text}) => {
  return <div className='s-title extra'>{text}</div>;
};

const PaymentNotificationText = ({text}) => {
  return <div className='s-title notification-value' dangerouslySetInnerHTML={{__html: text}} />;
};

const PaymentNotification = ({paymentData}) => {
  return (
    <div>
      <div className='d-flex debtpayment-notification-row'>
        <PaymentNotificationLabel text={'מספר אמסכתא: '} />
        <PaymentNotificationText text={paymentData.receptionNo} />
      </div>
      <div className='d-flex debtpayment-notification-row'>
        <PaymentNotificationLabel text={'סכום התשלום: '} />
        <PaymentNotificationText text={`₪${formatAmount(paymentData.Amount)}`} />
      </div>
      <div className='d-flex debtpayment-notification-row'>
        <PaymentNotificationLabel text={'תשלומים מספר:'} />
        <PaymentNotificationText text={paymentData.PaymentNo} />
      </div>
      <div className='debtpayment-notification-row payment-method-row'>
        <PaymentNotificationLabel text={'אמצעי תשלום: '} />
        <PaymentNotificationText text={`כרטיס אשראי שמסתיים<br />בספרות ${paymentData.CCFourLastNumbers} `} />
      </div>
      <div className='debtpayment-notification-row'>
        <PaymentNotificationLabel text={'אישור התשלום נשלח:'} />
        <PaymentNotificationText text={`ב-SMS למספר ${paymentData.phoneNumber}`} />
        {paymentData.invoiceByEmail && <PaymentNotificationText text={`ולכתובת מייל ${paymentData.customerEmail}`} />}
      </div>
    </div>
  );
};

export default PaymentNotification;
